import React, { useState } from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import {
  deleteReceiptAcknowledgement,
  getReceiptAcknowledgements,
  exportReceiptAcknowledgementTxt,
  programPayments,
  exportRA,
  cancelReceiptAcknowledgements,
} from "../../api/reciptAcknowledgement";
import LGModalCrud from "../LGCrud/LGModalCrud";
import ReceiptAcknowledgementForm from "./ReceiptAckowledgementForm";
import { currencyFormatterMXN } from "../../services/valueFormatters";
import LGModal from "../../molecules/LGModal";
import RAExportModal from "../../molecules/ReceiptAcknowledgements/RAExportModal";
import { useSnack } from "../../services/SnakbarProvider";
import dayjs from "dayjs";
import RAFileUpload from "../../molecules/ReceiptAcknowledgements/RAFileUpload";
import RAFilesTable from "../RA/RAFilesTable";
import RaPaymentTable from "./RaPaymentTable";
import { handlePrint as printPDF } from "../../services/PDFHandler.ts";
import ReceiptAcknowledgementRetentionVisualization from "./ReceiptAcknowledgementRetentionVisualization";

import DateFilterModal from "./DateFilterModal";
import SchedulePaymentsFromReceiptsModal from "./SchedulePaymentsFromReceiptsModal";

export default function ReceiptAcknowledgementCrud({ props }) {
  const { companyId } = props;
  const { openSnack } = useSnack();
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [dateFilterOpen, setDateFilterOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [showCanceled, setShowCanceled] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const now = new Date();
  const currentYear = now.getFullYear().toString().slice(-2);
  const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0");
  const [dateCode, setDateCode] = useState(`${currentYear}${currentMonth}`);

  const handleExport = async (params) => {
    try {
      const response = await exportReceiptAcknowledgementTxt(params);
      const fileName = `contrarrecibos_${dayjs().format(
        "YYYYMMDD_HHmmss"
      )}.txt`;

      // response.data is already a blob, no need to wrap it
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setExportModalOpen(false);
      openSnack("Archivo exportado exitosamente", "success");
    } catch (error) {
      openSnack("Error al exportar el archivo", "error");
    }
  };

  const handlePrint = async (id) => {
    try {
      const response = await exportRA(id);
      printPDF(response, "No se pudo generar el PDF", (error) => {
        openSnack("No se pudo generar el PDF", "error");
      });
    } catch (e) {
      openSnack("No se pudo generar el PDF", "erro.tsr");
    }
  };

  const handleSchedule = async (selectedRows) => {
    if (selectedRows.length === 0) {
      openSnack("No se seleccionaron contrarrecibos", "warning");
      return;
    }
    try {
      await programPayments(selectedRows);
      openSnack("Contrarrecibos programados exitosamente", "success");
    } catch (error) {
      console.log(error);
      openSnack("Error al programar los contrarrecibos", "error");
    }
  };

  const handleCancel = async (selectedRows) => {
    if (selectedRows.length === 0) {
      openSnack("No se seleccionaron contrarrecibos", "warning");
      return;
    }
    try {
      await cancelReceiptAcknowledgements(selectedRows);
      openSnack("Contrarrecibos cancelados exitosamente", "success");
    } catch (error) {
      console.log(error);
      openSnack("Error al cancelar los contrarrecibos", "error");
    }
  };

  const setStatusColor = (statusCode) => {
    switch (statusCode) {
      case "RA_POR_PAGAR":
        return "info";
      case "RA_EN_REVISION":
        return "warning";
      case "RA_PAGADO":
        return "success";
      case "RA_SCHEDULED":
        return "success";
      case "RA_PARTIALLY_SCHEDULED":
        return "warning";
      case "RA_CANCELLED":
        return "error";
    }
  };

  const handleDateFilter = (date) => {
    if (!date) {
      const now = new Date();
      const currentYear = now.getFullYear().toString().slice(-2);
      const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0");
      setDateCode(`${currentYear}${currentMonth}`);
      return;
    }

    const year = date.year().toString().slice(-2); // Get last 2 digits of year
    const month = (date.month() + 1).toString().padStart(2, "0"); // Month is 0-based

    // Update the fetchFunction parameters to include the filter
    const updatedParams = {
      ...props.data,
      code: `${year}${month}`,
    };

    // Refresh the data with the new filter
    setDateCode(`${year}${month}`);
  };

  return (
    <>
      <DateFilterModal
        open={dateFilterOpen}
        handleClose={() => setDateFilterOpen(false)}
        onSubmit={handleDateFilter}
      />
      <SchedulePaymentsFromReceiptsModal
        open={scheduleModalOpen}
        handleClose={() => setScheduleModalOpen(false)}
        companyId={companyId}
        onScheduled={() => setRefreshKey((k) => k + 1)}
      />
      <LGModal
        open={exportModalOpen}
        handleClose={() => setExportModalOpen(false)}
        header="Exportar Contrarrecibos"
      >
        <RAExportModal
          companyId={companyId}
          onSubmit={() => { }}
          onProgramPayments={() => setExportModalOpen(false)}
          onCsvExport={() => setExportModalOpen(false)}
        />
      </LGModal>

      <Box width={"100%"}>
        <LGModalCrud
          props={{
            actions: [
              "create",
              "update",
              "delete",
              "detail",
              "select",
              "print",
              "visualize",
            ],
            data: {
              companyId,
              code: dateCode,
              showCanceled,
              refreshKey,
            },
            fetchFunction: getReceiptAcknowledgements,
            deleteFunction: deleteReceiptAcknowledgement,
            printFunction: handlePrint,
            visualizeModalData: {
              header: "Regla de retencion activa",
              body: <ReceiptAcknowledgementRetentionVisualization />,
            },
            detailMenu: [
              {
                label: "Documentos",
                handler: () => { },
                header: "Documentos",
                body: <RAFilesTable />,
              },
              {
                label: "Pagos",
                handler: () => { },
                header: "Pagos",
                body: <RaPaymentTable />,
              },
            ],
            customButtons: [
              {
                label: "Filtrar por Mes/Año",
                icon: "calendar_month",
                color: "primary",
                onClick: () => setDateFilterOpen(true),
              },
              {
                label: "Opciones",
                icon: "more_vert",
                color: "primary",
                onClick: () => setExportModalOpen(true),
              },
              {
                label: "Programar Pagos",
                icon: "event_available",
                color: "secondary",
                onClick: () => setScheduleModalOpen(true),
              },
              {
                label: "Mostrar/Ocultar Cancelados",
                icon: "cancel",
                color: "secondary",
                onClick: () => setShowCanceled(!showCanceled),
              },
              {
                label: "Cancelar",
                icon: "cancel",
                color: "error",
                onClick: (selectedRows) => handleCancel(selectedRows),
                showOnlyWithSelection: true,
              },
            ],
            columns: [
              {
                field: "code",
                headerName: "No. Contrarrecibo",
                flex: 0.2,
              },
              {
                field: "providerCode",
                headerName: "Proveedor",
                valueGetter: (value, row) =>
                  row.provider ? `${row.provider.code}` : "",
                flex: 0.3,
              },
              {
                field: "invoiceNo",
                headerName: "No. Factura",
                flex: 0.3,
              },
              {
                field: "currency",
                headerName: "Moneda",
                flex: 0.2,
                valueGetter: (value, row) =>
                  row.currency ? `${row.currency.symbol}` : "",
              },
              {
                field: "total",
                headerName: "Total",
                flex: 0.2,
                ...currencyFormatterMXN,
              },
              {
                field: "status",
                headerName: "Estatus",
                flex: 0.2,
                renderCell: (params) => (
                  <Box
                    mt={2}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Chip
                      size="small"
                      label={params.row.status.name.toUpperCase()}
                      color={setStatusColor(params.row.status.code)}
                    />
                  </Box>
                ),
              },
              //   {
              //     field: "accounts",
              //     headerName: "Cuentas contables",
              //     flex: 0.5,
              //     renderCell: (params) => (
              //       <Stack direction={"column"}>
              //         {params.value.map((e) => (
              //           <Typography variant="body2" key={e.id}>
              //             {e.contpaqiAccountNo} - {e.description}
              //           </Typography>
              //         ))}
              //       </Stack>
              //     ),
              //   },
            ],
            addModalData: {
              header: "Agregar Contrarrecibo",
              body: <ReceiptAcknowledgementForm companyId={companyId} />,
            },
            editModalData: {
              header: "Editar Contrarrecibo",
              body: <ReceiptAcknowledgementForm companyId={companyId} />,
            },
          }}
        />
      </Box>
    </>
  );
}
